import React, { useState } from 'react';

import { Grid, Group, Select, TextInput } from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import { useDebouncedValue } from '@mantine/hooks';
import { IconSearch } from '@tabler/icons-react';
import ClassTypeSelect from 'components/form-fields/select-fields/ClassTypeSelect';
import { useAuth } from 'context/auth-context';

import WorkoutTableContainer from './components/WorkoutTableContainer';
import { WorkoutSortOption } from './types';

const sortOptions = [
  { value: 'default', label: 'Default Order' },
  { value: 'name', label: 'By Workout Name' },
  { value: 'classType', label: 'By Class Type' },
];

const Workouts = (): JSX.Element => {
  const { hasPerm } = useAuth();
  const canMutate = hasPerm('WorkoutMutate');

  const [search, setSearch] = useState<string>('');
  const [kiloClassTypeId, setKiloClassTypeId] = useState<string | null>(null);
  const [sortOption, setSortOption] = useState<WorkoutSortOption>('default');

  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([null, null]);
  const [pickerValue, setPickerValue] = useState<[Date | null, Date | null]>([null, null]);
  const handleDateRangeChange = (range: [Date | null, Date | null]): void => {
    setPickerValue(range);
    if (range[0] && range[1]) setDateRange(range);
    if (!range[0] && !range[1]) setDateRange([null, null]);
  };

  const [debouncedSearch] = useDebouncedValue<string>(search, 300);

  return (
    <>
      <Group
        position='apart'
        align='flex-end'
        sx={{ marginBottom: '1rem', marginTop: '1rem', flexShrink: 0 }}
      >
        <Grid sx={{ width: '100%' }}>
          <Grid.Col md={12} lg='auto'>
            <TextInput
              placeholder='Search workouts...'
              icon={<IconSearch size={16} />}
              value={search}
              onChange={e => setSearch(e.currentTarget.value)}
              style={{ minWidth: 300 }}
            />
          </Grid.Col>
          <Grid.Col md={4} lg={3}>
            <ClassTypeSelect
              placeholder='Filter by class type'
              value={kiloClassTypeId}
              onChange={setKiloClassTypeId}
            />
          </Grid.Col>
          <Grid.Col md={4} lg={3}>
            <DatePickerInput
              type='range'
              value={pickerValue}
              valueFormat='MM/DD/YYYY'
              onChange={handleDateRangeChange}
              allowSingleDateInRange
              clearable={true}
              {...{ placeholder: 'Filter by date range' }}
            />
          </Grid.Col>
          <Grid.Col md={4} lg={2}>
            <Select
              placeholder='Sort'
              value={sortOption}
              onChange={value => setSortOption((value as WorkoutSortOption) || 'default')}
              data={sortOptions}
            />
          </Grid.Col>
        </Grid>
      </Group>

      <WorkoutTableContainer
        permission={canMutate}
        search={debouncedSearch}
        sortOption={sortOption}
        kiloClassTypeId={kiloClassTypeId}
        dateRange={dateRange}
      />
    </>
  );
};

export default Workouts;
